import React from "react";

import { GridFull } from "~components/GridLayout";
import Share from "~components/Share";

import styles from "./featureLeftRail.module.css";

type LeftRailSectionProps = {
    children: React.ReactNode;
};

export function TopLeftRail(props: LeftRailSectionProps): JSX.Element {
    return <div className={styles.top}>{props.children}</div>;
}

export default function FeatureLeftRail(): JSX.Element {
    return (
        <GridFull className={styles.container}>
            <TopLeftRail>
                <Share className={styles.share} fixed vertical />
            </TopLeftRail>
        </GridFull>
    );
}
